import { BodyText } from '@calendly/ui/components/typography';
import classNames from 'classnames';
import { forwardRef } from 'react';
const wrapperCss = "w1kjp3rw";
export const Wrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(wrapperCss, props.className)} />;
});
const textWrapperCss = "t6519li";
export const TextWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(textWrapperCss, props.className)} />;
});
const titleCss = "t1l00ng7";
export const Title = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(titleCss, props.className)} />;
});
const emailCss = "e2qxa7o";
export const Email = forwardRef((props, ref) => {
  const color = 'muted';
  const size = 'small';
  return <BodyText ref={ref} {...props} color={color} size={size} className={classNames(emailCss, props.className)} />;
});

require("./shared.wyw-in-js.css!=!../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./shared.js");